export enum NewsletterSubscriptionScope {
  PerShop = 0,
  CompanyGroup = 1,
}
